export const SET_SIDEBAR_TYPE = 'sidebar/SET_SIDEBAR_TYPE';
export const setSidebarTypeAction = payload => ({
	type: SET_SIDEBAR_TYPE,
	payload,
});
